import React from 'react';
import { useAchievements } from '../../hooks/useAchievements';

interface SummaryCardsProps {
  setActiveTab: (tab: string) => void;
}

const SummaryCards: React.FC<SummaryCardsProps> = ({ setActiveTab }) => {
  const { loading, error, badgesCount, badgesTotal, passportsCount } = useAchievements();

  return (
    <section className="overview-tab summary-section flex flex-row gap-4 md:gap-20 justify-center my-8">
      <div className="w-full max-w-sm bg-white/30 border border-yellow-400 rounded-lg shadow-sm cursor-pointer" onClick={() => setActiveTab('badges')}>
        <div className="flex flex-col items-center py-4">
          <div className="w-20 h-20 mb-1 bg-gradient-to-br from-yellow-500 to-amber-400 rounded-full shadow-lg flex items-center justify-center">
            <img className="h-5/6 w-auto object-center" src="/pages/achievements/Digital-Badges.png" alt="Digital Badges"/>
          </div>
          <h5 className="text-4xl font-medium text-yellow-400 pt-2">{badgesCount || 0}</h5>
          <span className="text-base text-white pt-2">Badges Earned</span>
          <span className="text-sm text-white pt-2 text-center">of {badgesTotal || 0} total</span>
        </div>
      </div>
      
      <div className="w-full max-w-sm bg-white/30 border border-blue-400 rounded-lg shadow-sm cursor-pointer" onClick={() => setActiveTab('passport')}>
        <div className="flex flex-col items-center py-4">
          <div className="w-20 h-20 mb-1 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-full shadow-lg flex items-center justify-center">
            <img className="h-2/3 w-auto object-center" src="/pages/achievements/Digital-Passports.png" alt="Digital Passports"/>
          </div>
          <h5 className="text-4xl font-medium text-cyan-300 pt-2">{passportsCount || 0}</h5>
          <span className="text-base text-white pt-2">Digital Passports</span>
          <span className="text-sm text-white pt-2 text-center">Job role credentials earned</span>
        </div>
      </div>
    </section>
  );
};

export default SummaryCards;